export const NATIVE_CURRENCY_ADDRESS =
  '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';

export enum ContractAddress {
  AccessPassSale = '0x6e6518aFc0e6589F94052Cf91e668586495e2ecb',
  AuctionHouse = '0xa0A917D9E297B509A27E87C9105E809cFdF44843',
  // MogulMarketplace = '0x6015407aF2Ec688251Ed1c8673c48536b5d8dE87',
  MogulMarketplace = '0x07BFB924F29Fc02f4A92E608bBFf4d63ee9ceF89',
  MogulNft = '0xEd9e2b88FEB7A94A682E7E3a59631E15E8442711',
  // MogulMarketplaceErc721 = '0xC2751C85e4B096EBD077f1f602Ce1e898EE287Bc',
  MogulMarketplaceErc721 = '0x761317D378FB401829ecA5513189F7F91F122444',
  MogulNftErc721 = '0x0000000000000000000000000000000000000000',
  MogulNftV1 = '0x654CbE72aC1C7c0af5315622302BB717EE418f11',
  MogulMovieNft = '0x316a7c7E3cc126d1461F933fc4b295B84d37E70d',
  MogulMovieVoting = '0x59c2C7BF410c9051319C4444c80adc8247419948',
  MogulMovieMasterChef = '0x4be937b3C22F266dcb4f86C98b2Fa40A399EfAb7',
  // Stars = '0xc55c2175E90A46602fD42e931f62B3Acc1A013Ca',
  Stars = '0x88fd59e1DD3715A98bb66149DA9c944d9E795c12',
  StarsStaking = '0x88fd59e1DD3715A98bb66149DA9c944d9E795c12',
  StarsEth = '0x7c6c06d21f46664afd7d12197ce105651d29d1b0',
  StarsMasterChef = '0x3E279bA5872435A8722562bE1Dbae8CACf34D6B8',
  Usdc = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  Usdt = '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  SwapAddress = '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  Jancroon = '0xFb829A1b091045B9980548F8f18B6356bdD17C65',
  Mogies = '0x0000000000000000000000000000000000000000', //TODO: change to correct address
  DutchAuction = '0x2Eb636D3c7E4D8bBCfc3Cb624a2465B683F092C1',
  MogulNFTERC721Factory = '0x3b4C5132a61840A6319A71c3cA4e874d7FA632a3',
  MogulNFTERC1155Factory = '0x37c946A719C99Ea520eA56b3E7aDee2F9895a595',
  ERC1155MintableFactory = '0xc3Ea2339f6aC1c7B40084F68366690B23752e2E6',
}

export enum ContractAddressRinkeby {
  AccessPassSale = '0x398714d320b3dBf62F11e0B578C91f565749bbF1',
  AuctionHouse = '0xa80235381712Adc0435F8B21522be068878ce5A9',
  MogulMarketplace = '0xb5e2eBeAF73F457f460213b304177D66A4e90490',
  MogulNft = '0x47c92e992d982b0113f41dd3d405d7837461810a',
  MogulNftV1 = '0x0000000000000000000000000000000000000000',
  MogulMarketplaceErc721 = '0x8506B1A6204EDCd991656c019E52f01a0CA51E96',
  MogulNftErc721 = '0x6E3c909E747224dEab4b0bA638c0b4AE3af18484',
  MogulMovieNft = '0x6EaC5c59FDDb91bE90c706BC0D14A8C98Fc796e8',
  MogulMovieVoting = '0xb67826Fb199c3F6D9A4f017402487aaC7075759e',
  MogulMovieMasterChef = '0xEe97897f9478A56DE966b290B89ac17c2ce78242',
  Stars = '0xF37c8A532AE6B024E0942d0a922A330800C166Ab',
  StarsEth = '0xAe5E839d0b6cAB67B3AE7297faa44943bCf645bA',
  StarsMasterChef = '0x22628eC4Bd7EfC4Ce8EBA9fa33CAb5EFCC8F04DF',
  Usdc = '0xeb8f08a975ab53e34d8a0330e0d34de942c95926',
  SwapAddress = '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  Jancroon = '0xe9A7c132bFaCf612f1B3f99f9E8F465FA3A1162e',
  Mogies = '0x0000000000000000000000000000000000000000', //TODO: change to correct address
  StarsStaking = '0x4948ae39d514f4d11F0B070B60ACB1Cb1Cf548E9',
  DutchAuction = '0x39615c6A1E141d98B762c6b8c7aaF3e170208B2C',
  MogulNFTERC721Factory = '0x259D2C592ccF089eC9D55a6A52691DD9c2ae12B2',
  MogulNFTERC1155Factory = '0x299Fa21cA9B3B3052f04E44ce844A8aD5Fce0279',
  ERC1155MintableFactory = '0x0000000000000000000000000000000000000000',
}

export enum ContractAddressGoerli {
  // Stars = '0xd48AcC28607eC1f9e3083E336D3a805AB5B545fc',
  Stars = '0xe0aC1E17D4810d7d7a4680d825233e75960342b7',
  StarsMasterChef = '0x08e9C45C515274da6bdEac49f013E96015b644d5', // /platform/farming (ended)
  MogulNFTERC721Factory = '0x368313D33B2e6101B314B308B36624d1B692921C', // ERC721Factory
  MogulNFTERC1155Factory = '0x53F9FBa801c76838FB04Cf3738086881193d9f07', // ERC1155Factory
  ERC1155MintableFactory = '0xE65681DD13A427085CfddE4106487E5DFBbb9283', // ERC1155MintableFactory
  MogulNft = '0x5ceAAD459564133Ac8659Cc6767B2c30693d74Ad', // MogulERC115
  MogulNftErc721 = '0x362bFcA614f9dB32D2f3ccc98F5Fa84958cD9d9E', // MogulERC721
  // MogulMarketplace = '0x835c73a8C421c15eC6Ec69E09941ffB6c41971e9', // MogulMarketplaceERC1155
  MogulMarketplace = '0x4fe373A0539398481Edb0f29AaA6372BECcf6552',
  // MogulMarketplaceErc721 = '0xF60306e068E6431d09CB947687bbCcF263631488', // MogulMarketplaceERC721
  MogulMarketplaceErc721 = '0x55e7c32aFb7c55421b09153aab8106e6a5C16D85',
  MogulMovieNft = '0xab18d3a0b21F92D804bE3Fc587309F0209505860', // MogulERC1155
  MogulMovieMasterChef = '0xDb7666E9a6bcd5511eE13d131CdC9bF9e941a8AC', // VotingMasterChef
  MogulMovieVoting = '0xC8fb5b7a8EcA9128b0A5FbB1191A7adEafd352eE', // /platform/voting (ended)
  // StarsEth = '0xe44D8950a473D284c5Fa5172671db0B098048ec3',
  StarsEth = '0x9c74eeC0BB47B287309FAf1c114Dfd3Ec17E25eB', // UniswapV2Pair (SushiSwap Stars LP token)
  // https://goerli.etherscan.io/address/0x1b02da8cb0d097eb8d57a175b88c7d8b47997506  UniswapV2Router02
  AuctionHouse = '0x14D872EcdbA0E8737501Dc53a09cDFC033E8d843', // /platform/auction (ended) = MogulMarketplaceERC1155
  AccessPassSale = '0x9dBeCB522e1f15dBEf05e33f854b4162F7617B75', // unused
  SwapAddress = '0x7C9E349F8D0E87b8b57a9f44f833E64dd8997FAD', // UniswapV2Factory
  // StarsStaking = '0x57BBDF424DbfCB9Bb44bc3a0c9Ad167dbdedfaDC',
  StarsStaking = '0x4d6e35C59A3c188ab3520671267ca731D3fFCC8B', // /platform/starsStaking
  Mogies = '0x0000000000000000000000000000000000000000', //TODO: change to correct address
  DutchAuction = '0x0eEb484b05C0E66aaa8bA8d628dfBBf9f6466840', // unused
}

export enum ContractAddressBinanceTest {
  // MogulMarketplace = '0x9Dc50691b88dE7523C6FFeaa3B99725D849422bb',
  MogulMarketplace = '0x5eC219b744E076d36926728a27E0dE41ed164e47',
  // MogulMarketplaceErc721 = '0x3aC1d597be38EC83C68416381354fE3a6c229932',
  MogulMarketplaceErc721 = '0xD810f5C206d1A2003365a6ccC6901BF5F8432A36',
  MogulMovieNft = '0x9688c438d20df4658ced493ced0cb5b543e1794a',
  MogulNft = '0x5268Cf916ff35dEeaf258668b17BE07ba5eaDdf2',
  MogulNftErc721 = '0xE7516b71c4F802dEEaC09D13c13d8624515165A2',
  // Stars = '0x4f2357d747750f5eE85dE99041aaED4f5a04255C',
  Stars = '0xa2cC9a802b3355D80A3c0DdcC955B1015edE0393',
  // StarsBnb = '0x94B1B31c8e93a5B871c90C67a7508315a8A2ba60',
  StarsBnb = '0x94B1B31c8e93a5B871c90C67a7508315a8A2ba60',
  StarsStaking = '0x4Fb281eE05d4A17F160a6EE52dA9231036aF31d3',
  Usdc = '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
  Usdt = '0x7ef95a0FEE0Dd31b22626fA2e10Ee6A223F8a684',
  MogulMovieVoting = '0xD55838CCD4460E0329Ac7eD25E3F59e19FDC9b08',
  MogulMovieMasterChef = '0xD0eA5eD2181beB5E680fBB8352236f154F44111b',
  MogulNFTERC721Factory = '0xabc3B64da6ae54aF195e1c5BC1ecfbdF4B4B32Bf',
  MogulNFTERC1155Factory = '0xA24847170f864C5770BDfB6f1C77eaba9698a0Cc',
  ERC1155MintableFactory = '0x0000000000000000000000000000000000000000',
}

export enum ContractAddressBinance {
  // MogulMarketplace = '0x5eB4A9fc1E591cc9de5E235fA339BAa089261568',
  MogulMarketplace = '0x07BFB924F29Fc02f4A92E608bBFf4d63ee9ceF89',
  MogulMovieNft = '0x5924b03398267ce4836530ab5c15c4da459c0506',
  MogulNft = '0x08276ECbef63121dEa6d524D0fCdC2aFb99fBE65',
  // MogulMarketplaceErc721 = '0xe048c621C13fB0A5E7a27086eC314E0D67B12B55',
  MogulMarketplaceErc721 = '0x761317D378FB401829ecA5513189F7F91F122444',
  MogulNftErc721 = '0xE7516b71c4F802dEEaC09D13c13d8624515165A2',
  // Stars = '0xbd83010eb60f12112908774998f65761cf9f6f9a',
  Stars = '0x88fd59e1DD3715A98bb66149DA9c944d9E795c12',
  Usdc = '',
  Usdt = '0x55d398326f99059fF775485246999027B3197955',
  StarsBnb = '0xEDB1F18aE8AeE807a7A6fA1B03Cc02326AA3a95D',
  SwapAddress = '0xcF0feBd3f17CEf5b47b0cD257aCf6025c5BFf3b7',
  // StarsStaking = '0xfCBf5fb254415e844cEB500131d3793572a9fF60',
  StarsStaking = '0xCf23Cc9fCEB15e7e8948162A06b14B5e07B8a1A8',
  MogulMovieVoting = '0xf948250C81563084B8f0d00724223eefabaA035c',
  MogulMovieMasterChef = '0x7aed2B343e6E97577717553FCb70F54f2aaf73ff',
  MogulNFTERC721Factory = '0xf931cae738B4704ADD2390eD9b896f3d4B64f286',
  MogulNFTERC1155Factory = '0xbe84FFd63207e3fc70D35e9fFCDdBDB71fCF4F7A',
  ERC1155MintableFactory = '0x5D6eDf797Be8ca138b0640037Df8eff99269F048',
}

// address from https://docs.uniswap.org/protocol/V2/reference/smart-contracts/router-02
// for testnets and mainnet
export const UniswapRouterV2ContractAddress =
  '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D';

export const ApeswapRouterContractAddress =
  '0xcF0feBd3f17CEf5b47b0cD257aCf6025c5BFf3b7';

export const PancakeSmartRouterV3ContractAddressBinanceMainnet =
  '0x13f4EA83D0bd40E75C8222255bc855a974568Dd4';

export const PancakeSmartRouterV3ContractAddressBinanceTestnet =
  '0x13f4EA83D0bd40E75C8222255bc855a974568Dd4';

export const PancakeV3QuoterV2ContractAddressBinanceMainnet =
  '0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997';

export const IncludedNetworks = ['MAINNET'];

export const infuraId = '162e4613f58b45c5b4e08e7a681e4c76';

// Greater than 1000
export const nftWithBigSupply = [
  '0x08276ecbef63121dea6d524d0fcdc2afb99fbe65/1',
];

export const ExplorerUrl: Record<string, string> = {
  MAINNET: 'https://etherscan.io',
  ROPSTEN: 'https://ropsten.etherscan.io',
  RINKEBY: 'https://rinkeby.etherscan.io',
  GOERLI: 'https://goerli.etherscan.io',
  KOVAN: 'https://kovan.etherscan.io',
  BINANCE: 'https://bscscan.com',
  BSCTEST: 'https://testnet.bscscan.com',
};

export interface addressMappings {
  [key: string]: string;
}

export interface paymentMappings {
  [key: string]: addressMappings;
}

const defaultNativeAddresses: addressMappings = {
  MAINNET: '0x0000000000000000000000000000000000000000',
  ROPSTEN: '0x0000000000000000000000000000000000000000',
  RINKEBY: '0x0000000000000000000000000000000000000000',
  GOERLI: '0x0000000000000000000000000000000000000000',
  KOVAN: '0x0000000000000000000000000000000000000000',
  BINANCE: '0x0000000000000000000000000000000000000000',
  BSCTEST: '0x0000000000000000000000000000000000000000',
};

export const ERC1155MintablePaymentTokens: paymentMappings = {
  ETH: defaultNativeAddresses,
  BNB: defaultNativeAddresses,
  STARS: {
    MAINNET: ContractAddress.Stars,
    RINKEBY: ContractAddressRinkeby.Stars,
    GOERLI: ContractAddressGoerli.Stars,
    BINANCE: ContractAddressBinance.Stars,
    BSCTEST: ContractAddressBinanceTest.Stars,
  },
  // Stars has been changed to Mogul
  MOGUL: {
    MAINNET: ContractAddress.Stars,
    RINKEBY: ContractAddressRinkeby.Stars,
    GOERLI: ContractAddressGoerli.Stars,
    BINANCE: ContractAddressBinance.Stars,
    BSCTEST: ContractAddressBinanceTest.Stars,
  },
};

export const ERC1155MintablePaymentTokensMapping: paymentMappings = {
  MAINNET: {
    '0x0000000000000000000000000000000000000000': 'ETH',
    [ContractAddress.Stars]: 'STARS',
  },
  RINKEBY: {
    '0x0000000000000000000000000000000000000000': 'ETH',
    [ContractAddressRinkeby.Stars]: 'STARS',
  },
  GOERLI: {
    '0x0000000000000000000000000000000000000000': 'ETH',
    [ContractAddressGoerli.Stars]: 'STARS',
  },
  BINANCE: {
    '0x0000000000000000000000000000000000000000': 'BNB',
    [ContractAddressBinance.Stars]: 'STARS',
  },
  BSCTEST: {
    '0x0000000000000000000000000000000000000000': 'BSCTEST',
    [ContractAddressBinanceTest.Stars]: 'STARS',
  },
};

export const ERC1155InterfaceId = '0xd9b67a26';
export const ERC721InterfaceId = '0x80ac58cd';
export const ERC1155MintableFactoryInterface = '0xd9b67a26';
